export const CATEGORY_UNITS = {electricity: 'kWh', water: 'm³', gas: 'm³'}
export const DEFAULT_CATEGORY = 'electricity'

export const getUnit = (category) => CATEGORY_UNITS[category] || ''

export const formatNumber = (value, digits = 0) =>
    Number(value || 0).toLocaleString(undefined, {maximumFractionDigits: digits})

export const formatMoney = (value) => `${formatNumber(value)} ₪`

// null when there is nothing meaningful to compare against.
export const percentChange = (current, previous) =>
    previous > 0 ? ((current - previous) / previous) * 100 : null
